import { EventEmitter, Injectable, Output } from '@angular/core';
import firebase from 'firebase/app';
// import {User} from '../models/user.model';
// import {Contact} from '../models/contact.model';
@Injectable()
export class DealService {

  constructor() {

  }

  savedeals(newActiveForm) {
            newActiveForm.created_date =  new Date().getTime();
            newActiveForm.deleted = 0;
          return new Promise((resolve,reject)=>{
            firebase.firestore().collection("deal_details").add(newActiveForm).then(function (docRef) {
                
              let deal_id = docRef.id;
                docRef.update({
                  id:deal_id
                })
                resolve(newActiveForm);
              })
          })
        
  }

  getdeals(){

    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("deal_details").get().then(function (querysenap) {
        let deal_details = [];
        querysenap.forEach(function (contDoc) {
           let deal_data = contDoc.data();
            deal_details.push(deal_data);
          })
          resolve(deal_details);
        })
    })
  }

  getdealbyid(deal_id){

    return new Promise((resolve,reject)=>{
      firebase.firestore().collection("deal_details").where('id','==',deal_id).get().then(function (querysenap) {
 
        querysenap.forEach(function (contDoc) {
           let deal_data = contDoc.data();
           firebase.firestore().collection("users").where('uid','==',deal_data.contact_uid).get().then(function (querysenap1) {

              querysenap1.forEach(function (userDoc) {
                deal_data.user_data = userDoc.data();
              })
              firebase.firestore().collection("users").where('uid','==',deal_data.deal_owner).get().then(function (querysenap2) {
                  querysenap2.forEach(function (userDoc1) {
                    deal_data.broker_data = userDoc1.data();
                  })

                  resolve(deal_data);
              })
           })
            
          })
          
        })
    })
  }

}


// WEBPACK FOOTER //
// ./src/pages/newactive/services/deals.service.ts